module.exports = __webpack_public_path__ + "static/media/art7.3e0d7c24.jpg";